import ReactDOM from 'react-dom';
import router from './router';

ReactDOM.render(router, document.getElementById('root'));
